var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickyNote01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AEB7BE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.4,503.9c-103.9,0-207.8,0-311.7,0c-7.8-2.5-13-7.6-15.4-15.4c0-154.4,0-308.8,0-463.1 c2.5-7.8,7.6-13,15.4-15.4c154.4,0,308.8,0,463.1,0c7.8,2.5,13,7.6,15.4,15.4c0,103.9,0,207.8,0,311.7c-3.4,4.7-6.3,10-10.4,14.1 c-47.3,47.6-94.8,95.1-142.4,142.4C348.3,497.6,343.1,500.5,338.4,503.9z M466.3,313.6c0-88.8,0-176.8,0-264.9 c-138.9,0-277.4,0-416.2,0c0,138.9,0,277.6,0,416.3c88.3,0,176.3,0,264.8,0c0-2.2,0-4.1,0-6c0-41,0-82,0-123 c0-15.3,7.1-22.4,22.4-22.4c41,0,82,0,123,0C462.3,313.6,464.2,313.6,466.3,313.6z M437.5,352.5c-27.5,0-55.5,0-83.5,0 c0,28.3,0,56.2,0,83.5C381.8,408.2,409.7,380.3,437.5,352.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,276.2c-37.4,0-74.9,0-112.3,0c-14.2,0-23.6-12.5-19.3-25.4c2.5-7.3,9.2-12.5,16.9-13.1 c1-0.1,1.9,0,2.9,0c74.9,0,149.8,0,224.7,0c14.6,0,24.1,12.4,19.8,25.4c-2.7,8.1-10,13.1-19.3,13.1c-31.8,0-63.6,0-95.5,0 C269.7,276.2,263.7,276.2,257.8,276.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3,200.2c-37.4,0-74.9,0-112.3,0c-10.6,0-17.7-5.2-20.2-14.4c-2.8-10.2,3.6-21,13.9-23.4 c2.3-0.5,4.8-0.7,7.2-0.7c74.2,0,148.5,0,222.7,0c11,0,18.4,5,21,14.1c3.4,11.8-4.9,23.6-17.1,24.4c-1.9,0.1-3.9,0.1-5.8,0.1 C331.3,200.2,294.8,200.2,258.3,200.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNote01);
export default __webpack_public_path__ + "static/media/sticky-note-01.abece807bac9fd358a80f29dfdbef3fa.svg";
export { ForwardRef as ReactComponent };